import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import Helmet from 'react-helmet';
import GeneralHelper from '../../modules/General.js';
import OptionColumn from "../../components/general/OptionColumn";
import SplitRows from '../../components/general/SplitRow.js';
import General from '../../helpers/General.js';
import moment from 'moment';
import PushMessageEditor from "./forms/PushMessageEditor";
import Switch from 'rc-switch';

class Push extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:true,
            isError:false,
        }
        this.handleSave = this.handleSave.bind(this);
    }

    handleSave(res) {
        this.props.router.push(GeneralHelper.Link("/push"));
    }


    componentWillMount() {

    }

    render() {

        if(this.props.general.settings.PUSH_ACTIVE != '1') {
            return (
                <div className="full-height">
                    <div className="page-header">
                        <span className="page-title"><i className="icon fa-rocket"></i> Push notifications</span>
                    </div>
                    <div className="page-content">
                        <Helmet title="Push notifications | Crall.io" />

                        <div className="offset-sm-3 col-md-6 no-results">
                            <div className="panel panel-bordered" style={{border:'1px solid #e4eaec'}}>
                                <div className="panel-body text-center" style={{textAlign:'center'}}><br />
                                    <i className="icon wb-alert-circle" aria-hidden="true" style={{fontSize:'80px'}}></i>
                                    <p>
                                        <br />
                                        Push notifications is not enabled.
<br />
                                        <Link to={GeneralHelper.Link('/settings/push')} className="btn btn-default">Click here to configure push notifications</Link>
                                    </p>

                                    <br />
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            );
        }



        return (
            <div className="full-height">
                <div className="page-header">
                    <span className="page-title"><i className="icon fa-rocket"></i> New push notification</span>
                    <div className="page-header-actions">
                        <Link to={GeneralHelper.Link("/push")} className="btn btn-dark"><i className="icon fa-arrow-left" style={{marginRight:'10px'}}></i>  Back</Link>
                    </div>
                </div>
                <div className="page-content">
                    <Helmet title="Push Notifications | Crall.io" />

                    <PushMessageEditor enableSegment={this.props.general.settings.PACKAGE_SEGMENTS} save={this.handleSave} subdomain={this.props.general.settings.SUBDOMAIN} initialValues={{
                        icon:this.props.general.settings.LOGO_64x64,
                    }} />

                </div>
            </div>
        )

    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth,
        general:state.general
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({},dispatch)
}


Push = connect(mapStateToProps,mapDispatchToProps)(Push);
export default Push;


// WEBPACK FOOTER //
// ./containers/push/PushNew.js